<template>
    <multiselect
            v-model="choices"
            :options="neighborhoods"
            :multiple="true"
            placeholder="Vul in om te zoeken"
            track-by="value"
            label="text"
            selectLabel=""
            deselectLabel=""
            selectGroupLabel="Selecteer groep"
            deselectGroupLabel="Groep uit selectie verwijderen"
            selectedLabel=""
            :close-on-select="false"
            @select="onChangeAdd"
            @input="$emit('changed', {city, choices})"
    >
        <span slot="noResult">Er zijn geen wijken gevonden.</span>
    </multiselect>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: { Multiselect },
        name: 'PrefNeighborhood',
        props: {
            city: {
                type: String,
                default: ''
            },
            neighborhoods: {
                type: Array,
                default: [],
            },
            chosen: {
                type: Array,
                default: [],
            }
        },
        data() {
            return {
                choices: []
            }
        },
        mounted () {
            this.choices = this.chosen
        },
        methods: {
            onChangeAdd(val) {
                if(val.value === 'all') {
                    this.choices.splice(0, this.choices.length)
                } else {
                    this.choices.forEach((obj, i) => {
                        if(obj.value === 'all') {
                            this.choices.splice(i, 1)
                        }
                    })
                }
            },
        }
    }
</script>
